import { render, staticRenderFns } from "./Treatment.vue?vue&type=template&id=f7ede3aa&scoped=true"
import script from "./Treatment.vue?vue&type=script&lang=js"
export * from "./Treatment.vue?vue&type=script&lang=js"
import style0 from "./Treatment.vue?vue&type=style&index=0&id=f7ede3aa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ede3aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7ede3aa')) {
      api.createRecord('f7ede3aa', component.options)
    } else {
      api.reload('f7ede3aa', component.options)
    }
    module.hot.accept("./Treatment.vue?vue&type=template&id=f7ede3aa&scoped=true", function () {
      api.rerender('f7ede3aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Proposal/Treatment.vue"
export default component.exports